import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { addAddressQuestions } from '../questions';
import { FormTextField } from 'components/common';
import { IManualAddressAdditionProps } from './types';

export const ManualAddressAddition: FC<IManualAddressAdditionProps> = ({ requiredFieldErrorMessage }) => {
  return (
    <>
      <div className={'mt-2 w-full'}>
        <FormattedMessage id={addAddressQuestions.address1.labelKey} tagName={'h4'} />
        <FormTextField name={'address1'} rules={{ required: requiredFieldErrorMessage }} />
      </div>

      <div className={'mt-2 w-full'}>
        <FormattedMessage id={addAddressQuestions.address2.labelKey} tagName={'h4'} />
        <FormTextField name={'address2'} />
      </div>

      <div className={'mt-2 w-full'}>
        <FormattedMessage id={addAddressQuestions.city.labelKey} tagName={'h4'} />
        <FormTextField name={'city'} rules={{ required: requiredFieldErrorMessage }} />
      </div>

      <div className={'mt-2 w-full'}>
        <FormattedMessage id={addAddressQuestions.country.labelKey} tagName={'h4'} />
        <FormTextField name={'country'} rules={{ required: requiredFieldErrorMessage }} />
      </div>
    </>
  );
};
